import "../globals";
import React from "react";
import translate from "@deosite/helpers/langLibrary";
import Container from "@commerce-ui/core2/Container";
import Box from "@commerce-ui/core2/Box";

import PageContainer from "../containers/UI/PageContainer";
import MetaTags from "../components/MetaTags";

import InspirationsLandingBanner from "@deosite/components-new/InspirationsLandingBanner";
import ThreeInspirationBoxes from "@deosite/sections/ThreeInspirationBoxes";
import SectionWithConfigurableHeader from "../sections/SectionWithConfigurableHeader";

import {
  usePrismicInspirationsLanding,
  fetcher as prismicInspirationsLandingFetcher
} from "@deosite/api/hooks/prismic/usePrismicInspirationsLanding";
import Hit from "@deosite/components-new/Hit/HitHomePage";
const PromotionsLanding = props => {
  const { initialPrismicResponse, initialUid, lang } = props;

  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title")
  };

  const { data: prismicResponse } = usePrismicInspirationsLanding(
    initialUid,
    lang,
    initialPrismicResponse
  );

  return (
    <>
      <MetaTags
        description={
          prismicResponse?.seoDescription !== ""
            ? prismicResponse.seoDescription
            : translations.seoDescription
        }
        title={
          prismicResponse?.seoTitle !== ""
            ? prismicResponse.seoTitle
            : translations.seoTitle
        }
      />
      <PageContainer
        metaTagsData={{
          description: translations.seoDescription,
          title: translations.seoTitle
        }}
        recentlyViewedActive={false}
        footerContent={props.footerContent}
      >
        <Box sx={{ mt: ["s10", null, null, 78, null, null] }}>
          <SectionWithConfigurableHeader title={prismicResponse?.title}>
            <Box sx={{ mt: ["s10", null, null, 78, null, null] }}>
              <Container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column"
                }}
              >
                {prismicResponse?.content?.map(element => {
                  if (element.type === "banner") {
                    return (
                      <Box sx={{ mb: ["s10", null, null, "s13"] }}>
                        <InspirationsLandingBanner
                          label={element.label}
                          link={element.link}
                          leftImage={element.leftImage}
                          subtitle={element.subtitle}
                          title={element.title}
                          influencer={element.blogger}
                          backgroundColor={element.backgroundColor ?? "#FAF8F6"}
                          textColor={element.textColor ?? "#FAF8F6"}
                        />
                      </Box>
                    );
                  }
                  if (element.type === "boxes") {
                    return (
                      <Box sx={{ mb: ["s10", null, null, 142] }}>
                        <ThreeInspirationBoxes
                          link={element.url}
                          boxes={element.boxes}
                          label={element.label}
                        />
                      </Box>
                    );
                  }
                })}
              </Container>
            </Box>
          </SectionWithConfigurableHeader>
        </Box>
      </PageContainer>
    </>
  );
};

PromotionsLanding.getInitialProps = async props => {
  try {
    const { language } = props;
    const response = await prismicInspirationsLandingFetcher(
      global.__appConfig__.prismicPromotionsLandingUid,
      language
    );

    return {
      initialPrismicResponse: response,
      initialUid: "inspirationslanding",
      lang: language
    };
  } catch (error) {
    console.error(error);
    return error;
  }
};

export default PromotionsLanding;
